export default "__VITE_ASSET__51e0f4fe__"